import _ from "lodash"

export const trackEvent = (et, ed) => {
    console.log(et, ed)
    if (typeof window !== "undefined" && _.isFunction(window.gtag)) {
        window.gtag("event", et, {...ed})
    }
}